import { PractitionerSpecialtyAssociation } from '../../models/Entities/PractitionerAssociations/Specialties/PractitionerSpecialtyAssociation';
import { CommonState } from '../common/state/commonState';

export interface PractitionerSpecialtyAssociationState extends CommonState<PractitionerSpecialtyAssociation> {
  /** Todas las asociaciones del tenant (listado de practitioners); `list` sigue siendo la de un practitioner. */
  allAssociations: PractitionerSpecialtyAssociation[];
  isLoadingAllAssociations: boolean;
  successLoadingAllAssociations: boolean | undefined;
  failOnLoadingAllAssociations: boolean;
}

export const PractitionerSpecialtyAssociationUnloadState: PractitionerSpecialtyAssociationState = {
  isLoadingAll: false,
  successLoadingAll: undefined,
  failOnLoadingAll: false,
  isLoadingOne: false,
  successLoadingOne: undefined,
  failOnLoadingOne: false,
  isAddingNewOne: false,
  successAddingNewOne: undefined,
  failOnAddingNewOne: false,
  isUpdatingOne: false,
  successUpdatingOne: undefined,
  failOnUpdatingOne: false,
  isDeletingOne: false,
  successDeletingOne: undefined,
  failOnDeletingOne: false,
  list: [],
  error: undefined,
  allAssociations: [],
  isLoadingAllAssociations: false,
  successLoadingAllAssociations: undefined,
  failOnLoadingAllAssociations: false
};
